import { render, staticRenderFns } from "./Bags.vue?vue&type=template&id=cb076534"
import script from "./Bags.vue?vue&type=script&lang=js"
export * from "./Bags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports